import { render } from "./CertificateSummary.vue?vue&type=template&id=5282e9ca&scoped=true"
import script from "./CertificateSummary.vue?vue&type=script&lang=js"
export * from "./CertificateSummary.vue?vue&type=script&lang=js"

import "./CertificateSummary.vue?vue&type=style&index=0&id=5282e9ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5282e9ca"]])

export default __exports__